// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Belt_Result from "../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(partnerStatus) {
  switch (partnerStatus) {
    case "allocated" :
        return /* Allocated */1;
    case "free" :
        return /* Free */0;
    case "not_available" :
        return /* Not_Available */2;
    default:
      return ErrorUtils$Catalyst.raiseError("PartnerStatus.re", "Invalid 'partnerStatus' ", partnerStatus);
  }
}

function toString(partnerStatus) {
  switch (partnerStatus) {
    case /* Free */0 :
        return "free";
    case /* Allocated */1 :
        return "allocated";
    case /* Not_Available */2 :
        return "not_available";
    
  }
}

function t_decode(json) {
  return Belt_Result.map(Decco.stringFromJson(json), fromString);
}

export {
  fromString ,
  toString ,
  t_decode ,
  
}
/* No side effect */
